import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["email", "userInfo"]

  connect() {
    this.checkUserDebounced = this.debounce(this.checkUser.bind(this), 500)

    // Check on initial load if there's already a value
    if (this.emailTarget.value.trim()) {
      this.checkUserDebounced()
    }
  }

  emailChanged() {
    this.checkUserDebounced()
  }

  async checkUser() {
    const email = this.emailTarget.value.trim()
    if (!email || !this.isValidEmail(email)) {
      this.userInfoTarget.innerHTML = ""
      return
    }

    try {
      const response = await fetch(`/quanly/users/check_email?email=${encodeURIComponent(email)}`, {
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      })

      const data = await response.json()

      if (data.exists) {
        // Determine the current form type based on the URL
        const currentPath = window.location.pathname
        const isTeacherForm = currentPath.includes('/teachers/')
        const isMemberForm = currentPath.includes('/members/')
        const isStaffForm = currentPath.includes('/staffs/')

        // Check if user is already associated with a conflicting role
        const hasConflict = (isTeacherForm && (data.has_member || data.has_staff)) ||
                           (isMemberForm && (data.has_teacher || data.has_staff)) ||
                           (isStaffForm && (data.has_teacher || data.has_member))

        // Check if user is already associated with the same role
        const hasSameRole = (isTeacherForm && data.has_teacher) ||
                           (isMemberForm && data.has_member) ||
                           (isStaffForm && data.has_staff)

        let alertClass = 'alert-info'
        if (hasConflict) {
          alertClass = 'alert-danger'
        } else if (hasSameRole) {
          alertClass = 'alert-warning'
        }

        let message = `
          <div class="alert ${alertClass} mt-2">
            <strong>Người dùng đã tồn tại:</strong> ${data.full_name || email}
        `

        if (hasConflict) {
          message += `
            <p class="mb-0 small text-danger">
              <strong>Cảnh báo:</strong> Email này đã được liên kết với một vai trò khác.
              Việc sử dụng cùng một tài khoản cho nhiều vai trò có thể gây nhầm lẫn.
            </p>
          `
        } else if (hasSameRole) {
          let roleText = isTeacherForm ? 'giáo viên' : (isMemberForm ? 'hội viên' : 'nhân viên')
          message += `
            <p class="mb-0 small text-warning">
              <strong>Lưu ý:</strong> Email này đã được liên kết với một ${roleText} khác.
              Nếu tiếp tục, ${roleText} hiện tại sẽ được liên kết với tài khoản này thay thế.
            </p>
          `
        } else {
          message += `
            <p class="mb-0 small">Sẽ được liên kết với tài khoản người dùng này.</p>
          `
        }

        message += `</div>`
        this.userInfoTarget.innerHTML = message
      } else {
        this.userInfoTarget.innerHTML = `
          <div class="alert alert-warning mt-2">
            <strong>Người dùng mới:</strong> Một tài khoản mới sẽ được tạo với email này.
          </div>
        `
      }
    } catch (error) {
      console.error("Error checking user:", error)
      this.userInfoTarget.innerHTML = ""
    }
  }

  isValidEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return re.test(email)
  }

  debounce(func, wait) {
    let timeout
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout)
        func(...args)
      }
      clearTimeout(timeout)
      timeout = setTimeout(later, wait)
    }
  }
}
